module.exports = __webpack_public_path__ + "images/ds-cml2024-instructor-danielle-the-mobile.webp";